/*
Bar Pulls
  --length <float> | inches
*/
import { length } from '@/modules/standardItems/schemas/baseHeaders'
import hardwareHeaders from '@/modules/standardItems/schemas/hardware/headers'

export default [
  ...hardwareHeaders,
  length()
]
